import type { IRecord } from '@platform/core/types';
import type { ILawGroup } from './ILawGroup';
import { groupsInOrder, lawValue } from './lawGroups';

/** Статті за номером (прототип v4: sort((a, b) => (+a.num || 0) - (+b.num || 0)), рівні — у порядку запиту). Чиста функція. */
export function sortedArticles(items: readonly IRecord[]): IRecord[] {
  return items.map((r, i) => ({ r, i })).sort((a, b) => ((Number(a.r.values['num']) || 0) - (Number(b.r.values['num']) || 0)) || a.i - b.i).map((x) => x.r);
}

/** Скільки статей кожного типу норми — у порядку першої появи серед статей (пігулки «Визначення · 1»). Чиста функція. */
export function normCounts(arts: readonly IRecord[]): ILawGroup[] {
  return groupsInOrder(arts.filter((a) => lawValue(a, 'norm')), 'norm');
}

/** Суб'єкти, що трапляються в статтях як «хто» чи «щодо кого», у порядку варіантів поля (прототип SUB.filter(used)). Чиста функція. */
export function usedSubjects(arts: readonly IRecord[], order: readonly string[]): string[] {
  return order.filter((s) => arts.some((a) => lawValue(a, 'subject') === s || lawValue(a, 'counterparty') === s));
}

/** Статті, у яких `who` має норму щодо `to` (клітинка матриці суспільних відносин). Чиста функція. */
export function relationCell(arts: readonly IRecord[], who: string, to: string): IRecord[] {
  return arts.filter((a) => lawValue(a, 'subject') === who && lawValue(a, 'counterparty') === to);
}
